import { useEffect, useState } from 'react';
import { useDebouncedEffect } from './debounce';
import { LocationFeedService } from '../utility';

export const LocationFeedHook = warehouseId => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [totalData, setTotalData] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const [filter, setFilter] = useState({
    limit: 10,
    page: 1,
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const temp = {
        ...filter,
        warehouseId,
      };
      const res = await LocationFeedService.get(temp);
      setData(res?.data?.feeds || []);
      setTotalData(res?.totalCount);
      setTotalPages(res?.totalPages);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useDebouncedEffect(
    () => {
      if (warehouseId) {
        fetchData();
      }
    },
    [filter, refreshKey],
    500,
  );

  useEffect(() => {
    pageChanged(1);
  }, [warehouseId]);

  const pageChanged = page => {
    const temp = {
      ...filter,
      page,
    };
    setFilter({ ...temp });
  };

  const filterChanged = (key, value) => {
    const temp = {
      ...filter,
      page: 1,
      [key]: value,
    };
    setFilter({ ...temp });
  };

  const refresh = () => {
    setRefreshKey(Math.random());
  };

  return {
    data,
    error,
    filter,
    filterChanged,
    loading,
    pageChanged,
    totalData,
    totalPages,
    refresh,
  };
};
